import { useNavigate } from 'react-router-dom';
import { Table, StatusBadge, ActionCell, Button } from '@components/ui';
import { Users, Trash2, ChevronRight } from 'lucide-react';

export default function CustomersTable({ data, onDelete }) {
    const navigate = useNavigate();

    const formatCurrency = (amount) => {
        if (!amount) return '-';
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0,
        }).format(amount);
    };

    const getRoleVariant = (role) => {
        const variants = {
            customer: 'success',
            landowner: 'warning',
            investor: 'info',
        };
        return variants[role] || 'default';
    };

    const columns = [
        {
            key: 'name',
            header: 'Ad Soyad',
            width: 'lg',
            render: (val, row) => (
                <button
                    className="font-medium text-primary hover:underline text-left cursor-pointer"
                    onClick={() => navigate(`/finans/musteriler/${row.id}`)}
                >
                    {val}
                </button>
            ),
        },

        {
            key: 'phone',
            header: 'Telefon',
            width: 'md',
        },
        {
            key: 'tcNo',
            header: 'TC Kimlik',
            width: 'md',
            render: (val) => <span className="text-text-secondary">{val || '-'}</span>,
        },
        {
            key: 'roleLabel',
            header: 'Rol',
            width: 'sm',
            align: 'center',
            render: (val, row) => (
                <StatusBadge status={val} variant={getRoleVariant(row.role)} />
            ),
        },
        {
            key: 'totalPaid',
            header: 'Ödenen',
            width: 'md',
            align: 'right',
            render: (val) => <span className="text-success">{formatCurrency(val)}</span>,
        },
        {
            key: 'totalRemaining',
            header: 'Kalan',
            width: 'md',
            align: 'right',
            render: (val) => <span className="text-warning">{formatCurrency(val)}</span>,
        },
        {
            key: 'actions',
            header: '',
            width: 'sm',
            align: 'center',
            render: (val, row) => (
                <ActionCell>
                    <Button
                        variant="ghost"
                        size="xs"
                        onClick={() => navigate(`/finans/musteriler/${row.id}`)}
                    >
                        <ChevronRight size={16} />
                    </Button>
                    <Button
                        variant="ghost-error"
                        size="xs"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete?.(row);
                        }}
                    >
                        <Trash2 size={16} />
                    </Button>
                </ActionCell>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            data={data}
            showRowNumbers
            onRowClick={(row) => navigate(`/finans/musteriler/${row.id}`)}
            emptyMessage="Müşteri bulunamadı."
            emptyIcon={<Users size={40} />}
        />
    );
}
